// extracted by mini-css-extract-plugin
export default {"vessel":"style_vessel__EBcAu"};